import { isValueNumber } from './typeValidators';
export const getMonetaryValue = value => isValueNumber(value) ? "$".concat(parseFloat(value).toFixed(2)) : 'N/A';

/** Money that can go negative: a discount reads "-$3.60", not "$-3.60". */
export const getSignedMonetaryValue = value => {
  if (!isValueNumber(value)) return 'N/A';
  const amount = parseFloat(value);
  return amount < 0 ? "-".concat(getMonetaryValue(Math.abs(amount))) : getMonetaryValue(amount);
};